import { apiDirectoryService, apiService } from '@/services/APIService';

export default {
  showRegion(params) {
    return apiService.get('/regions', params);
  },

  getEventLevels() {
    return apiDirectoryService.getCached('/directory-event-levels');
  },

  getOrganizationTypes() {
    return apiDirectoryService.getCached('/organization-types');
  },

  getEventRequirements(params) {
    return apiDirectoryService.get('/directory-event-requirements', params);
  },

  getRegions(params) {
    return apiService.getCached('/public/regions', params);
  },

  getMuns(params) {
    return apiService.get('/public/municipalities', params);
  },

  getMunsCached(params) {
    return apiService.getCached('/public/municipalities', params);
  },

  showMun(id, params) {
    return apiService.get(`/public/municipalities/${id}`, params);
  },

  showMunCached(id, params) {
    return apiService.getCached(`/public/municipalities/${id}`, params);
  },

  getDirectoryRegions(params) {
    return apiDirectoryService.getCached('/regions', params);
  },

  showDirectoryMun(id, params) {
    return apiDirectoryService.get(`/municipalities/${id}`, params);
  },

  getEventMemberTypes(params) {
    return apiDirectoryService.get('/directory-event-member-types', params);
  },

  getInctructions(params) {
    return apiDirectoryService.get('/service-helps', params);
  },
  getInctructionsCached(params) {
    return apiDirectoryService.getCached('/service-helps', params);
  },

  showInctruction(id, params) {
    return apiDirectoryService.get(`/service-helps/${id}`, params);
  },
  showInctructionCached(id, params) {
    return apiDirectoryService.getCached(`/service-helps/${id}`, params);
  },

  departmentsOrganizationalForms() {
    return apiDirectoryService.getCached('/directory-organizational-forms');
  },

  // Департаменты
  departments() {
    return apiDirectoryService.getCached('/directory-departments');
  },

  // Типы образовательных организаций
  providerTypes() {
    return apiDirectoryService.get('/additional-provider-types');
  },

  getEventMemberAdditionalFields(params) {
    return apiDirectoryService.getCached('/directory-event-member-additional-fields', params);
  },

  getDirectoryEventDocuments(params) {
    return apiDirectoryService.getCached('/directory-event-documents', params);
  },

  timezones() {
    return apiService.getCached('/lists/timezones');
  },

  whitelistVchtOrganizations() {
    return apiService.getCached('/lists/vcht-users');
  },

  getDirectoryDocuments(params) {
    return apiService.get('/directory-documents', params);
  },

  createDirectoryDocument(params) {
    return apiService.post('/directory-documents', params);
  },

  updateDirectoryDocument(id, params) {
    return apiService.put(`/directory-documents/${id}`, params);
  },

  deleteDirectoryDocument(id) {
    return apiService.delete(`/directory-documents/${id}`);
  },

  /**
   *  params: {
   *    search[system_id]: number; // 2 - default config, 4 - vcht
   *    search[role]: RoleName; // 'certificate', 'member', etc
   *  };
   */
  getAnnouncements(params) {
    return apiDirectoryService.get('/update-systems', params);
  },

  getEventTypes(params) {
    return apiDirectoryService.get('/event-types', params);
  },

  getEventTypeItems(params) {
    return apiDirectoryService.get('/event-type-items', params);
  },

  getGlobalDocumentsType(params) {
    return apiService.get('/global-document-types', params);
  },
};
